require('./_location-information.scss')

const LocationInformation = {
    init: function (element) {
        const _ = this;
        console.log("SHOW LOCATION INFORMATION");
        // BUG ITEM is related to only CVS
        if (element === "cvs") {
            console.log("CVS");
            this.modifyLinkElements();
            this.modifyStrongElements();
        }
    },
    modifyLinkElements: function () {
        const aElements = document.getElementsByTagName('a');
        for (const aElement of aElements) {
            if (aElement.href && aElement.href.startsWith('tel:')) {
                console.log("START TEL");
                aElement.className = "link link--primary link--accent-underline";
                aElement.onmouseover = function () {
                    aElement.className = "link link--primary link--accent-underline hover";
                }
                aElement.onmouseout = function () {
                    aElement.className = "link link--primary link--accent-underline";
                }
            }
        }
    },
    modifyStrongElements: function () {
        const strongElements = document.getElementsByTagName('strong');
        for (const strongElement of strongElements) {
            strongElement.style["font-weight"] = "bold";
        }
    }
}

export default LocationInformation
